// extracted by mini-css-extract-plugin
module.exports = {"main_white":"#ffffff","exerc-lib__modal":"style_exerc-lib__modal__3wMOh"};